import React from "react";
import EmailSendingSuccess from "./EmailSendingSuccess";

export default () => <EmailSendingSuccess assetScope="passwordless" />;
